import Vue from 'vue'
import VueI18N from 'vue-i18n'
import _ from 'lodash'

Vue.use(VueI18N)

const i18n = new VueI18N({
  locale: 'zh-CN',
  fallbackLocale: 'zh-CN',
  messages: {
    'zh-CN': require('./lang/zh-CN').default
  }
})

Vue.filter('dataFormat', function (value, format = 'dateTime.onlyMonth', hasZero = true) {
  if (!value) return ''
  let monthArr = _.map(i18n.t('month').split('|'), (n) => _.trim(n))
  let dateTime = new Date(parseInt(value) || '')
  if (dateTime === 'Invalid Date') return ''

  let y = dateTime.getFullYear()
  let m = dateTime.getMonth() + 1
  if (hasZero && m < 10) m = '0' + m
  let mLocale = monthArr[dateTime.getMonth()]
  let d = dateTime.getDate()
  // eslint-disable-next-line
  if (hasZero && d < 10) d =  '0' + d
  let h = dateTime.getHours()
  // eslint-disable-next-line
  if (hasZero && h < 10) h = '0' + h
  let ms = dateTime.getMinutes()
  // eslint-disable-next-line
  if (hasZero && ms < 10) ms = '0'+ ms
  let s = dateTime.getSeconds()
  // eslint-disable-next-line
  if (hasZero && s < 10) s = '0' + s
  let mss = dateTime.getMilliseconds()
  return i18n.t(format, {year: y, month: m, monthLocale: mLocale, day: d, hour: h, minute: ms, seconds: s, msec: mss})
})

if (module.hot) {
  module.hot.accept(['./lang/zh-CN'], function () {
    i18n.setLocaleMessage('zh-CN', require('./lang/zh-CN').default)
  })
}

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js